
import Vue from 'vue'
import { mapGetters } from 'vuex'
import { SET_SNACKBAR, SET_SNACKBAR_SHOWING } from './store/mutation-types'

export default Vue.extend({
  name: 'App',
  computed: {
    ...mapGetters({
      isLoadingApp: 'isLoadingApp',
      snackbar: 'snackbar',
    }),
  },
  methods: {
    removeSnackbar() {
      this.$store.commit(SET_SNACKBAR_SHOWING, false)
      this.$store.commit(SET_SNACKBAR, {
        type: '',
        text: '',
        timeout: 2000,
        clearable: false,
      })
    },
  },
})
